module.exports = __webpack_public_path__ + "static/img/switch_blue.a244e252.png";